export const chartsTheme = {
    version: 1,
    themeName: "chartsTheme",
    theme: {
        seriesCnt: "12",
        backgroundColor: "rgba(0,0,0,0)",
        titleColor: "#09141b",
        subtitleColor: "#aaaaaa",
        textColorShow: false,
        textColor: "#333",
        markTextColor: "#eeeeee",
        color: [
            "#003049",
            "#d62828",
            "#20a39e",
            "#f77f00",
            "#1bbcdd",
            "#deb88d",
            "#027c9b",
            "#d15123"
        ],
        borderColor: "#fee4ce",
        borderWidth: "1",
        visualMapColor: [
            "#0097d4",
            "#a2d4e6"
        ],
        legendTextColor: "#333333",
        kColor: "#d62828",
        kColor0: "#20a39e",
        kBorderColor: "#d62828",
        kBorderColor0: "#20a39e",
        kBorderWidth: 1,
        lineWidth: 2,
        symbolSize: 4,
        symbol: "emptyCircle",
        symbolBorderWidth: 1,
        lineSmooth: false,
        graphLineWidth: 1,
        graphLineColor: "#aaaaaa",
        mapLabelColor: "#c12e34",
        mapLabelColorE: "#c12e34",
        mapBorderColor: "#eee",
        mapBorderColorE: "#ddd",
        mapBorderWidth: 0.5,
        mapBorderWidthE: 1,
        mapAreaColor: "#ddd",
        mapAreaColorE: "#e6b600",
        axes: [
            {
                type: "all",
                name: "通用坐标轴",
                axisLineShow: true,
                axisLineColor: "#333",
                axisTickShow: true,
                axisTickColor: "#333",
                axisLabelShow: true,
                axisLabelColor: "#333",
                splitLineShow: true,
                splitLineColor: [
                    "#ccc"
                ],
                splitAreaShow: false,
                splitAreaColor: [
                    "rgba(250,250,250,0.3)",
                    "rgba(200,200,200,0.3)"
                ]
            },
            {
                type: "category",
                name: "类目坐标轴",
                axisLineShow: true,
                axisLineColor: "#333",
                axisTickShow: true,
                axisTickColor: "#333",
                axisLabelShow: true,
                axisLabelColor: "#333",
                splitLineShow: false,
                splitLineColor: [
                    "#ccc"
                ],
                splitAreaShow: false,
                splitAreaColor: [
                    "rgba(250,250,250,0.3)",
                    "rgba(200,200,200,0.3)"
                ]
            },
            {
                type: "value",
                name: "数值坐标轴",
                axisLineShow: true,
                axisLineColor: "#333",
                axisTickShow: true,
                axisTickColor: "#333",
                axisLabelShow: true,
                axisLabelColor: "#333",
                splitLineShow: true,
                splitLineColor: [
                    "#ccc"
                ],
                splitAreaShow: false,
                splitAreaColor: [
                    "rgba(250,250,250,0.3)",
                    "rgba(200,200,200,0.3)"
                ]
            },
            {
                type: "log",
                name: "对数坐标轴",
                axisLineShow: true,
                axisLineColor: "#333",
                axisTickShow: true,
                axisTickColor: "#333",
                axisLabelShow: true,
                axisLabelColor: "#333",
                splitLineShow: true,
                splitLineColor: [
                    "#ccc"
                ],
                splitAreaShow: false,
                splitAreaColor: [
                    "rgba(250,250,250,0.3)",
                    "rgba(200,200,200,0.3)"
                ]
            },
            {
                type: "time",
                name: "时间坐标轴",
                axisLineShow: true,
                axisLineColor: "#333",
                axisTickShow: true,
                axisTickColor: "#333",
                axisLabelShow: true,
                axisLabelColor: "#333",
                splitLineShow: true,
                splitLineColor: [
                    "#ccc"
                ],
                splitAreaShow: false,
                splitAreaColor: [
                    "rgba(250,250,250,0.3)",
                    "rgba(200,200,200,0.3)"
                ]
            }
        ],
        axisSeperateSetting: true,
        toolboxColor: "#06467c",
        toolboxEmphasisColor: "#4187c2",
        tooltipAxisColor: "#cccccc",
        tooltipAxisWidth: 1,
        timelineLineColor: "#20a39e",
        timelineLineWidth: 1,
        timelineItemColor: "#003049",
        timelineItemColorE: "#1bbcdd",
        timelineCheckColor: "#f77f00",
        timelineCheckBorderColor: "#003049",
        timelineItemBorderWidth: 1,
        timelineControlColor: "#20a39e",
        timelineControlBorderColor: "#027c9b",
        timelineControlBorderWidth: 0.5,
        timelineLabelColor: "#09141b",
        datazoomBackgroundColor: "rgba(47,69,84,0)",
        datazoomDataColor: "rgba(47,69,84,0.3)",
        datazoomFillColor: "rgba(167,183,204,0.4)",
        datazoomHandleColor: "#a7b7cc",
        datazoomHandleWidth: "100",
        datazoomLabelColor: "#333333"
    }
}